import type { LocationQueryValue } from "#vue-router";

// Transform query params that are meant to be read as an array to be read as an array, and vice versa.
const transformRouteParams = <
  I extends string,
  T extends "string" | "array" = "string",
  R = T extends "string" ? I | undefined : I[] | undefined,
>(
  param: undefined | LocationQueryValue | LocationQueryValue[],
  to: T,
): R => {
  let transformedParam: string | string[] | undefined;

  if (Array.isArray(param) && param[0]) {
    if (to === "array") {
      transformedParam = param.filter(Boolean) as string[];
    } else {
      transformedParam = param[0];
    }
  }

  if (typeof param === "string") {
    if (to === "string") {
      transformedParam = param;
    } else {
      transformedParam = [param];
    }
  }

  return (transformedParam ?? undefined) as R;
};

export default transformRouteParams;
